import Table from '@oncolens/oncolens-ui/lib/components/Common/Table';
import React from 'react';
import { useQueryClient } from 'react-query';
// eslint-disable-next-line import/no-extraneous-dependencies
import { useNavigate } from 'react-router';
import {
  getGuidelineTemplates,
  GuidelineTemplateDto,
  useDeleteGuidelineTemplate,
} from '../api/guideline-template';
import { GuidelineTemplateKeys } from '../api/guideline-template.keys';
import ActionsColumn from './ActionsColumn';

type GuidelineTemplateTableProps = {
  searchQuery: string;
};

export default function GuidelineTemplateTable({ searchQuery }: GuidelineTemplateTableProps) {
  const columns = React.useMemo(
    () => [
      { accessor: 'actions', Header: '', Cell: GuidelineActionsColumn, stopClickPropagation: true },
      { accessor: 'name', Header: 'Template Name' },
      {
        accessor: 'updatedDate',
        Header: 'Updated Date',
        Cell: DateColumn,
      },
    ],
    [],
  );

  const filters = {
    ...(searchQuery && { Filters: `(Name)@=*${searchQuery}` }),
  };

  const navigate = useNavigate();
  const navigateToEdit = (rowData: any) => navigate(`template/${rowData.id}`);

  return (
    <Table
      columns={columns}
      onRowClick={navigateToEdit}
      fetchData={getGuidelineTemplates}
      queryBaseKey="guidelineTemplates"
      additionalQueryParameters={filters}
      options={{ textSize: 'sm' }}
    />
  );
}

interface GuidelineTemplateTableRowProps {
  row: {
    original: GuidelineTemplateDto;
  };
}
const GuidelineActionsColumn = ({ row }: GuidelineTemplateTableRowProps) => {
  const { original: data } = row;
  const queryClient = useQueryClient();
  const deleteGuidelineTemplate = useDeleteGuidelineTemplate(data.id, {
    onSuccess: () => {
      queryClient.invalidateQueries(GuidelineTemplateKeys.lists());
    },
  });
  const onDelete = (toggle: () => void) =>
    deleteGuidelineTemplate.mutateAsync().then(() => toggle());

  return (
    <ActionsColumn
      onDelete={onDelete}
      modalTitle="Delete Guideline Template"
      modalContent="Are you sure you want to delete this template?"
      deleteItemTestSelector="guideline-template-delete-button"
      deleteModalTestSelector="delete-guideline-template-modal"
      deleteItemConfirmationTestSelector="delete-guideline-template-modal-confirm"
    />
  );
};

const DateColumn = ({ row: { original: rowData } }: GuidelineTemplateTableRowProps) => (
  <div className="flex flex-col space-y-1">{rowData.updatedDate.toLocaleString()}</div>
);
